import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function ConsistentIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3514">
      <div className="relative w-full h-full bg-gradient-to-br from-blue-50 to-indigo-100 overflow-hidden" data-id="element-3515">
        {/* Background: Giant Calendar */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3516">
          <g transform="translate(40, 20) scale(1.2)" data-id="element-3517">
            {/* Calendar Board */}
            <rect x="0" y="10" width="100" height="100" rx="8" fill="#FFFFFF" stroke="#CBD5E1" strokeWidth="2" data-id="element-3518" />
            <rect x="0" y="10" width="100" height="25" rx="8" fill="#EF4444" data-id="element-3519" />
            <rect x="0" y="25" width="100" height="10" fill="#EF4444" data-id="element-3520" />

            {/* Rings */}
            <rect x="20" y="0" width="6" height="20" rx="3" fill="#94A3B8" data-id="element-3521" />
            <rect x="74" y="0" width="6" height="20" rx="3" fill="#94A3B8" data-id="element-3522" />

            {/* Grid */}
            <path d="M0 55 L100 55 M0 75 L100 75 M0 95 L100 95" stroke="#E2E8F0" strokeWidth="1" data-id="element-3523" />
            <path d="M25 35 L25 110 M50 35 L50 110 M75 35 L75 110" stroke="#E2E8F0" strokeWidth="1" data-id="element-3524" />

            {/* Checkmarks */}
            {isUnlocked && <g stroke="#22C55E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-3525">
                <path d="M5 45 L10 50 L20 40" data-id="element-3526" />
                <path d="M30 45 L35 50 L45 40" data-id="element-3527" />
                <path d="M55 45 L60 50 L70 40" data-id="element-3528" />
                <path d="M80 45 L85 50 L95 40" data-id="element-3529" />

                <path d="M5 65 L10 70 L20 60" data-id="element-3530" />
                <path d="M30 65 L35 70 L45 60" data-id="element-3531" />
                <path d="M55 65 L60 70 L70 60" data-id="element-3532" />
                <path d="M80 65 L85 70 L95 60" data-id="element-3533" />
              </g>}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[5%]" data-id="element-3534">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3535">
            <DjaySpecimen look={{
            variant,
            accessory: 'trophy'
          }} size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3536" />
          </div>
        </div>

        {/* Foreground: Desk/Floor */}
        <svg className="absolute bottom-0 left-0 w-full h-1/5 z-20 pointer-events-none" viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3537">
          <path d="M0 20 L200 20 L200 40 L0 40 Z" fill="#94A3B8" opacity="0.2" data-id="element-3538" />
        </svg>
      </div>
    </DjayIllustrationBase>;
}